import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="w-full bg-white border-b border-gray-100">
      <div className="max-w-5xl mx-auto flex items-center justify-between px-4 md:px-6 py-3">
        <Link to="/" className="text-lg md:text-xl font-bold text-gray-900 tracking-tight hover:text-sphere-orange-dark transition-colors">
          アイチモータース
        </Link>
        <a
          href="tel:0562349210"
          className="flex items-center gap-1.5 text-sm text-gray-700 hover:text-sphere-orange-dark transition-colors"
        >
          <i className="ri-phone-line text-sphere-orange-dark" />
          <span className="hidden sm:inline">0562-34-9210</span>
        </a>
      </div>
    </header>
  );
}